import { useTranslation } from 'react-i18next';

import { Box, Button, Card, Grid, Typography } from '@frontierag/frontier-ui-library';
import { Warning as WarningIcon } from '@frontierag/frontier-ui-library/icons';

import { styles } from './styles';
import type { IProductCard } from './types';

const ProductCard = ({ product, title, quantity, price, actions, hasError }: IProductCard) => {
  const { t } = useTranslation('CreateOrder');
  const { packageDescription = '' } = product.productData || {};
  return (
    <Card variant="outlined" sx={styles.cardWrapper} data-testid="product-card">
      <Grid container direction="column" spacing={0.5}>
        <Grid item display="flex" justifyContent="space-between">
          <Typography variant="label1">{title}</Typography>
          {hasError && <WarningIcon color="warning" fontSize="small" />}
        </Grid>
        <Grid item mt={1}>
          <Typography variant="label2" pr={1} color="grey.L20">
            {t('viewBasket.card.bagSize')}
          </Typography>
          <Typography variant="label1">{packageDescription}</Typography>
        </Grid>
        <Grid item mt={1}>
          <Typography variant="label2" pr={1} color="grey.L20">
            {t('viewBasket.card.productQuantity')}
          </Typography>
          <Typography variant="label1">{quantity}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle2" pb={2} color="primary">
            {price}
          </Typography>
        </Grid>
        <Box display="flex" justifyContent="flex-end" gap={1}>
          {actions.map((action, index) => (
            <Button
              key={index}
              variant="contained"
              startIcon={action.icon}
              onClick={() => action.onActionClick(product)}
              color="secondary"
              size="small"
              sx={{ width: '50%' }}
            >
              {action.title}
            </Button>
          ))}
        </Box>
      </Grid>
    </Card>
  );
};
export default ProductCard;
